import {userConstants} from '../_constants';

export function personalManager(state = {}, action) {
  switch (action.type) {
    case userConstants.PERSONAL_MANAGER_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case userConstants.PERSONAL_MANAGER_SUCCESS:
      return {
        ...state,
        ...action.data,
        loading: false,
      };
    case userConstants.PERSONAL_MANAGER_FAILURE:
      return {
        error: action.error,
      };

    default:
      return state;
  }
}